import 'css-chunksrc/client/pages/utilityPage/projectModelsPage/projectModel/styles.scss';export default {
  "projectModel": "_projectModel_gur9i_1",
  "name": "_name_gur9i_15",
  "description": "_description_gur9i_21",
  "buttons": "_buttons_gur9i_27",
  "edit": "_edit_gur9i_39",
  "button": "_button_gur9i_27"
};